import { createSlice } from "@reduxjs/toolkit";
import {
  createClassThunk,
  deleteClassThunk,
  fetchClasses,
  updateClassThunk,
} from "./classThunk";

const initialState = {
  classes: [],
  loading: false,
  error: null,
  showForm: false,
  editingClass: null,
};

const classSlice = createSlice({
  name: "class",
  initialState,
  reducers: {
  setSelectedClassId: (state, action) => {
    state.selectedClassId = action.payload;
  },
  setSelectedSubjectId: (state, action) => {
    state.selectedSubjectId = action.payload;
  },
  setSelectedChapterId: (state, action) => {
    state.selectedChapterId = action.payload;
  },
  setChapterName: (state, action) => {
    state.chapterName = action.payload;
  },
  setEditingChapter: (state, action) => {
    state.editingChapter = action.payload;
  },
  setEditingClass: (state, action) => {
    state.editingClass = action.payload;
  },
  setSubjects: (state, action) => {
    state.subjects = action.payload;
  },
  setShowForm: (state, action) => {
  state.showForm = action.payload;
},

  setChapters: (state, action) => {
    state.chapters = action.payload;
  },
  setClasses: (state, action) => {
    state.classes = action.payload;
  },
},

  extraReducers: (builder) => {
    builder
      .addCase(fetchClasses.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchClasses.fulfilled, (state, action) => {
        state.classes = action.payload;
        state.loading = false;
      })
      .addCase(fetchClasses.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createClassThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createClassThunk.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createClassThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateClassThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateClassThunk.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateClassThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteClassThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteClassThunk.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteClassThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export const { setShowForm, setEditingClass } = classSlice.actions;
export default classSlice.reducer;
